import { loadPackage } from "common/utils/package-loader";

export default class DropzoneClass {
  #dropzoneOptions;

  #dropzone;

  #dropzoneSelector;

  constructor(
    props = {
      dropzoneSelector: "",
      dropzoneOptions: {}
    }
  ) {
    this.#dropzoneSelector = props.dropzoneSelector;
    this.#dropzoneOptions = props.dropzoneOptions;
  }

  get $dropzone() {
    return document.querySelector(this.#dropzoneSelector);
  }

  get dropzone() {
    return this.#dropzone;
  }

  get dropzoneOptions() {
    return this.#dropzoneOptions;
  }

  async initDropzone() {
    if (this.$dropzone && !this.#dropzone) {
      const DropzoneConstructor = await loadPackage("dropzone");

      this.#dropzone = new DropzoneConstructor(this.$dropzone, this.dropzoneOptions);
      this.#dropzone.on("success", this.dropzoneSuccess.bind(this));
      this.#dropzone.on("addedfile", this.dropzoneAddedFile.bind(this));
      this.#dropzone.on("processing", this.dropzoneProcessing.bind(this));
      this.#dropzone.on("complete", this.dropzoneComplete.bind(this));
    }
  }

  /** @abstract */
  dropzoneSuccess() {
    return this;
  }

  /** @abstract */
  dropzoneAddedFile() {
    return this;
  }

  /** @abstract */
  dropzoneProcessing() {
    return this;
  }

  /** @abstract */
  dropzoneComplete() {
    return this;
  }
}
